import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class Reports extends BaseModel {
  constructor() {
    super(collection(db, 'reports'))
  }
}
